import { takeLatest } from 'redux-saga/effects';
import {
  getPerfReviewListSuccess, getPerfReviewListFail,
  getPerfReviewDetailsSuccess, getPerfReviewDetailsFail,
  getPendingPerfReviewListSuccess, getPendingPerfReviewListFail,
  doPerfReviewUpdateSuccess
} from './performanceReviewState';
import createCrudService from '../../services/crudservice';
import { 
  doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
  createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/workforce/performance-reviews');
const redirectData = { route:'/console/performance-reviews', mode:'list', recordId:0 };
const modelName = 'Performance Reviews';
const modelId = 'pfr_id';

function* getPerfReviewList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getPerfReviewListSuccess,
    getPerfReviewListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getPerfReviewDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getPerfReviewDetailsSuccess,
    getPerfReviewDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doPerfReviewCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getPerfReviewDetailsSuccess,
    getPerfReviewDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    SAVING_MSG
  );
}

function* doPerfReviewUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(data.payload[modelId], data.payload),
    doPerfReviewUpdateSuccess,
    getPerfReviewDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode: 'reload' },
    UPDATING_MSG
  );
}

function* doPerfReviewDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getPerfReviewDetailsSuccess,
    getPerfReviewDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode:data.payload.mode },
    DELETING_MSG
  );
}

function* getPendingPerfReviewList(data){
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getPendingPerfReviewListSuccess,
    getPendingPerfReviewListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* PerfReviewSaga() {
  yield takeLatest('performanceReview/getPerfReviewList', getPerfReviewList);
  yield takeLatest('performanceReview/getPerfReviewDetails', getPerfReviewDetails);
  yield takeLatest('performanceReview/doPerfReviewCreate', doPerfReviewCreate);
  yield takeLatest('performanceReview/doPerfReviewUpdate', doPerfReviewUpdate);
  yield takeLatest('performanceReview/doPerfReviewDelete', doPerfReviewDelete);
  yield takeLatest('performanceReview/getPendingPerfReviewList', getPendingPerfReviewList);
  
}

export default PerfReviewSaga;
